const React = require('react');
import PropTypes from 'prop-types';
import createClass from 'create-react-class';
const _ = require('lodash');

const SimpleTable = createClass({
  propTypes: {
    headers: PropTypes.array,
    data: PropTypes.arrayOf(PropTypes.array),
    className: PropTypes.string
  },

  attachClass(currentClass, classToAdd) {
    return currentClass ? currentClass + ' ' + classToAdd : classToAdd;
  },

  render() {
    let {data, headers, className} = this.props;

    let classes = 'vf-table';
    if (className) classes += ' ' + className;

    return (
      <table className={classes}>
        <thead>
          <tr>
            {_.map(headers, (header, index) => {
              return (
                <th key={index}>
                {header}
                </th>
              );
            })}
          </tr>
        </thead>

        <tbody>
          {
            _.flatten(_.map(data, (row, indexRow) => {
              const {columns, ...props} = row;

              if (_.isPlainObject(row)) {
                if (props.onClick) {
                  let classToAdd = 'vf-table-clickable';
                  let className = props.className;
                  props.className = this.attachClass(className, classToAdd);
                }
              }

              return (
                <tr className='tr-item' key={indexRow}>
                  {
                    _.map(columns || row, (cell, cellIndex) => {
                      return (
                        <td key={cellIndex}>
                          {(_.isPlainObject(cell) && cell.render) ? cell.render : cell}
                        </td>
                      );
                    })
                  }
                </tr>
              );
            }))
          }
        </tbody>
      </table>
    );
  }
});

module.exports = SimpleTable;
